import React, { useState, useEffect } from 'react'

const UsernameValidator = ({ onChange, currentUsername = '' }) => {
  const [username, setUsername] = useState(currentUsername)
  const [status, setStatus] = useState(null)
  const [isChecking, setIsChecking] = useState(false)

  useEffect(() => {
    const checkUsername = async () => {
      if (username.length < 3) {
        setStatus({ type: 'warning', message: 'Username must be at least 3 characters' })
        return
      }

      setIsChecking(true)
      try {
        const response = await fetch(`/users/check_username?username=${encodeURIComponent(username.toLowerCase())}`)
        const data = await response.json()

        if (data.valid) {
          setStatus({ type: 'success', message: 'This username is available! ✨' })
          onChange && onChange(username, true)
        } else {
          setStatus({ type: 'error', message: 'This username is already taken' })
          onChange && onChange(username, false)
        }
      } catch (error) {
        console.error('Error checking username:', error)
        setStatus({ type: 'error', message: 'Error checking username' })
      } finally {
        setIsChecking(false)
      }
    }

    const timeoutId = setTimeout(() => {
      if (username) checkUsername()
    }, 500)

    return () => clearTimeout(timeoutId)
  }, [username])

  const getStatusColor = () => {
    switch (status?.type) {
      case 'success': return 'text-green-600'
      case 'error': return 'text-red-600'
      case 'warning': return 'text-yellow-600'
      default: return ''
    }
  }

  return (
    <div className="space-y-2">
      <input
        type="text"
        name="user[username]"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        placeholder="e.g., CuriousLearner22, MathWhiz2024"
        className="rounded-lg border-gray-300 focus:ring-yellow-500 focus:border-yellow-500 w-full text-gray-900"
      />
      {status && (
        <div className={`text-sm ${getStatusColor()} flex items-center bg-white bg-opacity-90 px-3 py-1 rounded-md`}>
          {isChecking ? (
            <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          ) : null}
          {status.message}
        </div>
      )}
      <div className="mt-2 text-sm text-gray-500">
        <h4 className="font-medium text-white">Username Info:</h4>
        <ul className="list-disc pl-5 space-y-1 mt-1 text-white">
            <li>This will be your display name in the learning world and on the leaderboard</li>
            <li>You can also use this username to sign in to your account</li>
            <li>At least 3 characters long</li>
            <li>Can contain letters, numbers, and underscores</li>
            <li>Cannot contain spaces or special characters</li>
            <li>Will be visible if sharing content</li>
        </ul>
      </div>
    </div>
  )
}

export default UsernameValidator